import React from 'react';
import { Box, Palette, Typography } from '@mui/material';
import { InformationChip } from '@europrocurement/flexy-components';
import { Link } from 'react-router-dom';

interface ClientOpereInfoProps {
    clientOpere: {
        raisonSociale: string;
        siren?: string;
        urlToSocieteDotCom?: string;
    };
    palette: Palette;
}

export const ClientOpereInfo: React.FunctionComponent<ClientOpereInfoProps> = function ({
    clientOpere,
    palette,
}) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <Typography
                variant="l2dbodys"
                color="text.gris60"
            >
                SIREN:
            </Typography>

            {clientOpere.siren ? (
                <Typography
                    variant="l2dbodys"
                    color="text.gris70"
                    sx={{ fontWeight: 500 }}
                >
                    {clientOpere.siren}
                </Typography>
            ) : (
                <Typography
                    variant="l2dbodys"
                    color="text.gris70"
                    sx={{ fontWeight: 500 }}
                >
                    À renseigner
                </Typography>
            )}
            {clientOpere.urlToSocieteDotCom && (
                <Link
                    to={clientOpere.urlToSocieteDotCom}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none' }}
                >
                    <InformationChip
                        color={palette.grey[600]}
                        label={<Typography variant="l2dbodys">Societe.com</Typography>}
                        icon={['fasl', 'arrow-up-right-from-square']}
                    />
                </Link>
            )}
        </Box>
    );
};
